var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","justify-center":""}},[_c('p',{staticClass:"text-center text-h4"},[_vm._v("About Page")])])}
var staticRenderFns = []

export { render, staticRenderFns }